// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.75.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.75.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suspense-fallback-suspenseFallback-39bb6{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.suspense-fallback-suspenseFallback-39bb6 .suspense-fallback-content-df0d3{height:100px;width:100px}.suspense-fallback-suspenseFallback-39bb6 .acud-spin-container:after{background:#0000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suspenseFallback": "suspense-fallback-suspenseFallback-39bb6",
	"content": "suspense-fallback-content-df0d3"
};
export default ___CSS_LOADER_EXPORT___;
